export type ApiKeyStatus = 'active' | 'revoked';

export interface ApiKeyCreatedBy {
  email: string;
  name: string;
}

export class ApiKey {
  id!: string;
  name!: string;
  prefix!: string;
  status!: ApiKeyStatus;
  lastUsedAt: string | null = null;
  revokedAt: string | null = null;
  createdAt!: string;
  createdBy: ApiKeyCreatedBy | null = null;
  key: string | null = null;

  constructor(data: any = {}) {
    this.id = data.id;
    this.name = data.name;
    this.prefix = data.prefix;
    this.status = data.status;
    this.lastUsedAt = data.last_used_at ?? null;
    this.revokedAt = data.revoked_at ?? null;
    this.createdAt = data.created_at;
    this.createdBy = data.created_by ?? null;
    this.key = data.key ?? null;
  }

  get isActive(): boolean {
    return this.status === 'active';
  }
}
